import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import { bin } from 'react-icons-kit/icomoon/bin';
import JoditEditor from 'jodit-react';
const {htmlToText} = require('html-to-text');
var Config = require('../../config');

class ModalNotes extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.saveNotes = this.saveNotes.bind(this);
		this.setContent = this.setContent.bind(this);
		this.getNotes = this.getNotes.bind(this);
		this.showAllNotes = this.showAllNotes.bind(this);
		this.disableNote = this.disableNote.bind(this);


		this.state = {
		    show: false,
			notes:"",
			alerts:"",
			saved_alerts:[],
			options:[{key:"note",value:"Nota"},{key:"alert",value:"Alerta"}],
			donor_id:"",
			saved_notes:[],
			alert_id:"",
			config:{
				buttonsSM: ['bold', 'italic', 'underline', 'strikethrough', 'eraser', 'ul', 'ol', 'font', 'fontsize', 'indent', 'outdent'],
				readonly:false,
				language: "es",
				autofocus:true
			},
			all_notes: false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false, notes:"", notes:"",	alerts:"",donor_id:"", all_notes:false});
	}

	handleShow(id, show) {
		this.getNotes(id, show, true);

	}

	getNotes(id, show, modal, actives = true){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donation_notes/by_donor?donor_id='+id+'&actives='+actives,{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var notes = [];
				var alert = [];
				response.res.map((res)=>{
					if(res.note.type.toUpperCase() !== 'ALERT'){
						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'DONOR_NOTE'){
							screen = 'Búsqueda de Donador';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						notes.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: htmlToText(res.note.note),
							active: res.note.active
						});
								 
					}else{
						this.setState({alert_id:res.note.id});

						var screen = '';

						if(res.note.proces_type === 'EXTRACION'){
							screen = 'EXTRACIÓN';
						}

						if(res.note.proces_type === 'CLINIC_HISTORY'){
							screen = 'HISTORIA CLINICA';
						}

						if(res.note.proces_type === 'REGISTER'){
							screen = 'REGISTRO';
						}

						if(res.note.proces_type === 'DONOR_NOTE'){
							screen = 'Búsqueda de Donador';
						}

						if(res.note.proces_type === 'LABORATORY'){
							screen = 'LABORATORIO';
						}

						alert.push({
							screen: screen,
							id: res.note.id,
							user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
							note: htmlToText(res.note.note),
							active: res.note.active
						});

					}

				})


				if(modal){
					this.setState({show: true});
				}
				this.setState({
					donor_id:id,
					saved_alerts:alert,
					
					saved_notes:notes,
					only_show:show
				});
			}
		})
	}

	handleChange = (event) => {
		if(event.target.value.length <= 500){
			if(event.target.name === 'notes'){
				if(this.state.option === 'alert'){
					this.setState({
						alerts: event.target.value,
						[event.target.name]: ''
					});

				}else{
					this.setState({
						[event.target.name]: event.target.value,
						alerts: this.state.alerts !== "" ? this.state.alerts : "",
					});
				}
			}else{
				this.setState({
					[event.target.name]: event.target.value,
					alerts:this.state.alerts !== "" ? this.state.alerts : "",
					notes:""
				});
			}	
		}
		
	}

	saveNotes(){
		var valid = this.state.option === 'alert' ? this.state.alerts : this.state.notes;
		var option = this.state.option === 'alert' ? 'alerta' : 'nota';

		if(valid.trim() === ""){
			swal('¡Atención!', "La "+option+" no puede estar vacia", 'warning');
		}else{
			var obj = {}, url = 'donation_notes';
			obj = {
				proces_type:"DONOR_NOTE",
				type:this.state.option,
				note:this.state.option !== "alert" ? this.state.notes : this.state.alerts,
				donor_id: parseInt(this.state.donor_id,10) || null,
				//offers_id: parseInt(this.state.offers_id, 10) || null,
			}

			if(this.state.alert_id !== "" && this.state.option === "alert") {
				obj.id = this.state.alert_id;

				url = 'donation_notes/'+this.state.alert_id;
			}

			//lab_sections
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+url, {
				method : this.state.alert_id !== "" && this.state.option === "alert" ? 'put' : 'post',
				body: JSON.stringify(obj), // data can be `string` or {object}!
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept' 		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(error) {
	                swal('¡Error', error, 'error');
	              });
		        }
		    })
			.then(response =>{
				if(response !== undefined){
					
					this.setState({ show: false,notes:"", notes:"",	alerts:"",donor_id:""});
				}
					
			});
		}
	}

	setContent(val){
		if(this.state.option === 'note'){
			this.setState({notes: val});
		}else if(this.state.option === 'alert'){
			this.setState({alerts: val});
		}else{
			this.setState({notes: "", alerts:""});
		}
	}

	disableNote(e, id){
		e.preventDefault();

		swal({
			title: '¿Desea eliminar la nota?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				fetch(Config.default.apiGateway.URL+'donation_notes/inactive/'+id,{
					method:'post',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getNotes(this.state.donor_id, this.state.only_show, false, this.state.all_notes ? null : true);
					}
				});
			}
		});
	}

	showAllNotes(e){
		this.setState({all_notes: !this.state.all_notes});

		this.getNotes(this.state.donor_id, this.state.only_show, false, e.target.checked ? null : true);
		
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_notes.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		<div className="form-group col-xs-12 col-sm-4">
				        	<span className="span-min">Tipo</span>
							<select className="form-control" name="option" id="option" value={this.state.option}
								onChange={this.handleChange}>
								<option value="">Seleccionar...</option>
				                {
				                this.state.options.map(function(t) {
				                	return <option  key={t.key}  value={t.key} >{t.value} </option>;
				                })
				            }
				            </select>
				        </div>
				        
			        	<div className="col-xs-12 form-group">
		        			<div className="col-xs-12">
		        				<input type="checkbox" name="all_notes" id="all_notes" value={this.state.all_notes}
		        					checked={this.state.all_notes} onChange={(e)=>this.showAllNotes(e)} /> <span className="span-min">Ver todos</span>
		        			</div>
		        			<div className="col-xs-12">									
								<table className="table">
									<tbody style={{display:'block', height:'200px', overflowY:'auto'}}>
									{this.state.option === 'note' ? 
										this.state.saved_notes.map((note, i)=>
											<tr key={i} style={{width:'100%', display:'grid'}}>
												<td>
													<div className="col-xs-11">
														<div className="col-xs-12" style={{textAlign:'right'}}>
															{note.user_date}
														</div>
														<div className="col-xs-12">
															<div>{note.screen}</div>
															<div>{note.note}</div>	
														</div>
													</div>
													<div className="col-xs-1">
														{note.active &&
															<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																<SvgIcon icon={bin}/>
															</button>
														}															
													</div>

												</td>
											</tr>
										)
									: this.state.option === 'alert' ?
										this.state.saved_alerts.map((note, i)=>
											<tr key={i} style={{width:'100%', display:'grid'}}>
												<td>
													<div className="col-xs-11">
														<div className="col-xs-12" style={{textAlign:'right'}}>
															{note.user_date}
														</div>
														<div className="col-xs-12">
															<div>{note.screen}</div>
															<div>{note.note}</div>	
														</div>
													</div>
													<div className="col-xs-1">
														{note.active &&
															<button className="btn btn-info btn-xs" onClick={(e)=>this.disableNote(e, note.id)}>
																<SvgIcon icon={bin}/>
															</button>
														}															
													</div>

												</td>
											</tr>
										)
									: null
									}
									</tbody>
								</table>
							</div>

	        			</div>

						<div className="col-xs-12">
							<JoditEditor 
								ref={ref => this.editor = ref}
								value={this.state.option === 'alert' ? this.state.alerts : this.state.notes}
								config={this.state.config}
								tabIndex={1}
								onChange={newContent => this.setContent(newContent)}
							/>
						</div>
						
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	{this.state.only_show === undefined ?
		        		<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.saveNotes}/>
		        	:null}		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalNotes);